import Vue from 'vue';
import $ from 'jquery';
import t from '../main/i18n';

if (document.querySelector('.webinar-access-form')) {
  Vue.config.delimiters = ['[[', ']]'];

  new Vue({
    el: '.webinar-access-form',
    comments: true,
    data: {
      error: false,
      hasAccess: false,
      localStorageItemName: 'webinarAccess',
      googleTrackingCodes: {},
      form: {
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        country: '',
        postal_code: '',
        role: '',
        relationship: '',
        opt_in: true,
        webinar_id: ''
      }
    },
    mounted() {
      this.googleTrackingCodes = JSON.parse(
        document.querySelector('.webinar').dataset.googleTrackingCodes
      );

      if (localStorage.getItem(this.localStorageItemName)) {
        this.hasAccess = true;
      }
    },
    methods: {
      view(webinarId) {
        const webinarObject = JSON.parse(
          localStorage.getItem(this.localStorageItemName)
        );

        if (webinarObject) {
          this.form = {
            first_name: webinarObject.first_name,
            last_name: webinarObject.last_name,
            email: webinarObject.email,
            company: webinarObject.company,
            country: webinarObject.country,
            postal_code: webinarObject.postal_code,
            role: webinarObject.role,
            relationship: webinarObject.relationship,
            opt_in: webinarObject.opt_in,
            webinar_id: webinarId
          };

          this.record();
          this.trackGAEvent();
        }
      },
      record() {
        if (!this.hasAccess) {
          const formData = new FormData(this.$refs['form']);
          for (let [key, val] of formData.entries()) {
            this.form[key] = val;
          }
        }

        $.ajax({
          method: 'POST',
          url: '/sloan-webinar-access/record',
          data: this.form
        })
          .done(() => {
            this.error = false;
            this.hasAccess = true;
            localStorage.setItem(
              this.localStorageItemName,
              JSON.stringify(this.form)
            );
          })
          .catch(response => {
            this.hasAccess = false;
            localStorage.removeItem(this.localStorageItemName);

            const message = JSON.parse(response.responseText);
            if (Object.prototype.hasOwnProperty.call(message, 'error')) {
              this.error = message.error;
            } else {
              this.error =
                t('Webinar Registration failed. Please try again.');
            }
          });
      },
      trackGAEvent() {
        const trackingCode = this.googleTrackingCodes['webinar_video_view'];

        window.ga('send', 'event', {
          eventCategory: trackingCode.category,
          eventAction: 'View',
          eventLabel: trackingCode.label
        });
      }
    }
  });
}
